import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { EditorTemplateComment } from '@/modules/export/_modules/editor/models/EditorTemplateComment';

export class EditorTemplateCommentThread extends BaseEntityModel {
  id?: number;
  threadId?: string;
  editorTemplateId?: number;
  attributes?: Record<string, unknown>;
  context?: Record<string, unknown>;
  resolvedBy?: number;
  resolvedAt?: string;
  archivedAt?: string;
  unlinkedAt?: string;
  editorTemplateComments?: Relationship<EditorTemplateComment[]> | null;

  constructor(model: Partial<EditorTemplateCommentThread> = {}) {
    super(model);

    this.id = model.id;
    this.threadId = model.threadId;
    this.editorTemplateId = model.editorTemplateId;
    this.attributes = model.attributes;
    this.context = model.context;
    this.resolvedBy = model.resolvedBy;
    this.resolvedAt = model.resolvedAt;
    this.archivedAt = model.archivedAt;
    this.unlinkedAt = model.unlinkedAt;
    this.editorTemplateComments = EditorTemplateComment.mapModels(model.editorTemplateComments);
  }
}
